/* Three fish, one line each.
 *
 * The level scale carries a number, and a number is a thing you read. These
 * are a thing you glance at -- a farmer on a boat deck wants to know whether
 * anything is wrong before they want to know what it is, and a shape answers
 * that faster than 135 does.
 *
 * They differ in ONE stroke. Same body, same tail, same eye, and a mouth that
 * turns up, flattens, or turns down. Anything more -- a slumped posture, a
 * cartoon frown, an exclamation mark -- and it stops being an instrument
 * reading and becomes an opinion with a face on it. One curve is enough to
 * read across a room and small enough to stay quiet when nothing is wrong.
 *
 * Drawn in `currentColor` and nothing else, so the state is set once by the
 * scale and the icon inherits it.
 */

export type Mood = 'ok' | 'warn' | 'bad'

/** The mouth, and it is the only thing that changes.
 *
 *  Drawn well forward and well clear of the eye. At the size this renders --
 *  about 34 device-independent pixels -- an expression tucked under the eye is
 *  two marks a few pixels apart and resolves to a smudge; separated, the
 *  curvature is legible at a glance, which is the entire job. */
const MOUTH: Record<Mood, string> = {
  ok: 'M24.4 13.7 C25.8 16.3 28.3 15.8 29.4 13.2',
  warn: 'M25.0 14.9 L29.2 14.4',
  bad: 'M24.4 15.9 C25.8 13.3 28.3 13.8 29.4 16.4',
}

export function Fish({ mood }: { mood: Mood }) {
  return (
    <svg
      viewBox="0 0 34 22"
      width="40"
      height="26"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.45"
      strokeLinecap="round"
      strokeLinejoin="round"
      data-mood={mood}
      aria-hidden="true"
    >
      {/* Tail, then body. Pointed where they meet, so the two shapes read as
          one animal rather than as a triangle beside an oval. */}
      <path d="M10 11 L2.8 5.8 L2.8 16.2 Z" />
      <path d="M10 11 C10 6 15.5 3.2 22 3.2 C27.2 3.2 31 6.6 31 11
               C31 15.4 27.2 18.8 22 18.8 C15.5 18.8 10 16 10 11 Z" />
      <circle cx="25" cy="8.9" r="1.4" fill="currentColor" stroke="none" />
      <path d={MOUTH[mood]} />
    </svg>
  )
}
